import React, { Component } from 'react'
import { currentPage, itemPerPage } from "../../constants/index";

import Toolbar from '@material-ui/core/Toolbar';
import { connect } from 'react-redux';
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import Alert from 'react-s-alert';
import { CommunitySelect } from '../../utils/engageComponents';

import { sweetAlert } from '../../components/Alert/sweetAlert'

//views
import AddEditCommunity from '../../views/community/AddEditCommunityV2'
import AddEditResdient from '../../views/community/AddEditResdient'
import AddEditDeviceV2 from '../../views/community/AddEditDeviceV2'
import CommunitySettings from '../../views/community/CommunitySettings';
import Locations from '../../views/community/Locations';
import AppsView from '../apps/AppsView';
import ModalExternalIdBind from './ModalExternalIdBind';


//Actions
import { getAllCommunities, getCommunityById, delCommunity, getCommunityByIdAsync, UpdateCommuntyImage } from '../../actions/communityActions'
import { ClearVersions } from '../../actions/versionActions'
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { GetAllDevices, ClearDevices } from '../../actions/deviceActions';

//Engage SettingsInputComponentSharp
import {
    RenderImageLoaderCommunity
} from '../../utils/engageComponents';

//FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClipboardList,
    faFilter,
    faGlobe,
    faSortAmountDown,
    faSortAmountUpAlt,
    faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { IconButton } from '@material-ui/core';
import Modal from '@material-ui/core/Modal'
//import LocationsV2 from './LocationsV2';
import { UpdateCurrentLocation } from '../../actions/currentUrlActions';


class Community extends Component {
    constructor(props) {
        super(props)

        this.state = {
            openCommunity: false,
            openResident: false,
            openDevice: false,
            openLocation: false,
            openCommunitySettings: false,
            isLoading: false,
            currentPage: currentPage,
            itemPerPage: itemPerPage,
            isAddCommunity: false,
            communityExists: false,
            //residents
            isUpdResident: false,
            //tabSelected
            tabSelected: 0,
            //Save resident disabled
            onErrorSelectedResidentFirstName: false,
            onErrorSelectedResidentLastName: false,
            communitySelected: undefined,
            //CommunityImage
            selectedCommunityImage: undefined,
            objBase64selectedCommunityImage: undefined,
            //devices
            isUpdateDevice: false,
            selectedDevices: [],
            deviceSelected: undefined,
            //rootFontSize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            communitySelectOpen: false,
            enableCLSyncButton: false,
            showModalSyncCL: false,
            anchorEl: null,
            //sort Resident
            reverseResident: false,
            //Resident
            residentFiltersOpen: false,
            residentsFiltersAnchorElId: undefined,

            //DeviceFilters
            deviceFiltersOpen: false,
            deviceFiltersAnchorElId: undefined,

            //interval
            umbralInMinutes: 5,
        };
    };

    //#region  Styles
    objStyles = {
        tabsStyle: {
            backgroundColor: '#454446'
        },
        tabStyles: {
            backgroundColor: '#1f1f1f',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            color: 'white',
            textTransform: 'none',
        },
        SelectedTabStyle: {
            backgroundColor: '#454446',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            color: 'white',
            textTransform: 'none',
        },
        swipeableViews: {
            width: '100%',
            backgroundColor: '#454446'
        },
        GridColum: {
            borderRadius: '9px',
            backgroundColor: '#1f1f1f',
            paddingTop: '.6rem',
            paddingBottom: '1.5rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            minHeight: '55px',
            cursor: 'pointer',
            color: '#F0EFEF'
        },
        GridColumDisabled: {
            borderRadius: '9px',
            backgroundColor: '#1f1f1f',
            paddingTop: '.6rem',
            paddingBottom: '1.5rem',
            paddingLeft: '.5rem',
            paddingRight: '.5rem',
            minHeight: '35px',
            cursor: 'not-allowed',
            color: '#F0EFEF'
        },
        titleEngage: {
            color: '#686868',
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'left'
        },
        themeContainer: {

        },
        image: {
            borderRadius: '9px',
            width: '85%',
            height: '75px'

        },
        GridElement: {
            padding: '.6rem'
        },
        GridElementSelected: {
            padding: '.6rem',
            //opacity:'0.3'
            border: '1px solid white'
        },
        GridSection: {
            margin: 'auto'
        },
        GridText: {
            textAlign: 'left',
            fontSize: '14px',
            fontFamily: 'Gotham, Book',
            color: '#818081'
        },
        TitleSection: {
            color: 'white',
            textAlign: 'left'
        }
    }
    //#endregion

    componentDidMount() {
        document.title = 'Community'
        this.InitialLoading();
    };

    InitialLoading = () => {
        this.SetHeaderButtons(
            {
                openResident: this.state.openResident,
                openCommunity: this.state.openCommunity,
                openDevice: this.state.openDevice,
                openCommunitySettings: this.state.oppenCommunitySettings,
                isUpdateDevice: this.state.isUpdateDevice,
                selectedDevices: this.state.selectedDevices,
                isUpdResident: this.state.isUpdResident,
                communityExists: this.state.communityExists,
                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                communitySelected: this.state.communitySelected,
                community: this.state.communitySelected,
                method: 'did Mount',
            }
        );

        this.GetAllCommunities();

        window.addEventListener("resize", this.resize.bind(this));

        setTimeout(() => {
            this.resize();
        }, 200);
    }

    componentWillUnmount() {
        this.props.SetHeaderButtons(undefined);
        window.removeEventListener("resize", this.resize.bind(this));
    };

    handlerSaveClick = () => {
        var link = document.getElementById('save_Community_Settings_btn')
        link.click()
    }

    handlerHomeTiles = () => {
        var link = document.getElementById('open_Community_Home_App')
        link.click()
    }

    SetHeaderButtons = (options) => {
        if (options) {

            const headerButtons = this.getHeaderButtons(options);
            this.props.SetHeaderButtons(headerButtons)
        }
    };

    getHeaderButtons = (options) => {

        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
        }
        const windowWidth = window.innerWidth;

        return (
            localStorage.getItem('superAdmin') === "true" || (options.openResident || options.openCommunity || options.openDevice || options.openCommunitySettings) ?
                <div className="setupInfoSection" style={styles.globalActions}>
                    {
                        !options.openResident && !options.openCommunity && !options.openDevice && !options.openCommunitySettings ?

                            localStorage.getItem('superAdmin') === "true" ?

                                <Grid>
                                    {
                                    }
                                    <div id='community_Btn_AddCommunity' className="appbtn-engage skybluebtn-engage appbtn-list-engage appbtnBarButton" onClick={this.handleaddAdd} style={styles.globalActions}>
                                        Add Community
                                    </div>
                                </Grid>
                                :
                                <div></div>
                            :
                            <div className="appbtn-list-engage" style={styles.globalActions}>
                                {
                                    options.openCommunity ?
                                        <React.Fragment>
                                            <div id='community_Btn_SaveCommunity' className="appbtnBarButtonv2 blueButton" onClick={this.SaveCommunity}>
                                                Save Community
                                            </div>
                                            {/*<Grid item
                                                id='Add_Activity_Btn'
                                                className={this.state.enableCLSyncButton ? "appbtnBarButtonv2 greenbtn-engage" : "appbtnBarButtonv2 disabledSkybluebtn-engage"} onClick={this.SyncCLCommunity}>
                                                Sync Community CL
                                </Grid>*/}
                                            {/*<div className="appbtn-engage redbtn-engage">
                                    Cancel
                                </div>*/}
                                        </React.Fragment>
                                        : options.openDevice ?
                                            <React.Fragment>
                                                {
                                                    <React.Fragment>
                                                        {/*  
                                        <div id='updatedevicebtn' className={(localStorage.getItem('superAdmin') === "true")?'appbtn-engage yellowbtn-engage':'appbtn-engage skybluebtn-angage'}
                                            style={{backgroundColor:'#e8db34', color:'black',cursor:(localStorage.getItem('superAdmin') === "true")?'pointer':'not-allowed'}} 
                                            disabled={true} //onClick={this.EditDevice} 
                                        >
                                            Update
                                        </div> */
                                                        }
                                                        {
                                                            (options.isUpdateDevice && this.state.deviceSelected) ?
                                                                <Grid id='device_btn_SaveDevice' className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.SaveDevice}>
                                                                    Save
                                                                </Grid>
                                                                :
                                                                <>
                                                                    <Grid id='device_btn_RegisterDevice' className="appbtn-engage purplebtn-engage appbtnBarButton" onClick={this.ExportDevice}>
                                                                        Export Devices
                                                                    </Grid>
                                                                    <Grid id='device_btn_RegisterDevice' className="appbtn-engage skybluebtn-engage appbtnBarButton" onClick={this.NewDevice}>
                                                                        Register
                                                                    </Grid>
                                                                </>
                                                        }
                                                        <Grid id='device_btn_reboot' onClick={this.Reboot}
                                                            className={(options.isUpdateDevice || options.selectedDevices.length > 0) ? 'appbtn-engage redbtn-engage appbtnBarButton' : 'appbtn-engage disabledSkybluebtn-engage appbtnBarButton'}>
                                                            Reboot
                                                        </Grid>
                                                        <Grid id='device_btn_message' onClick={this.Message}
                                                            className={(options.isUpdateDevice || options.selectedDevices.length > 0) ? 'appbtn-engage purplebtn-engage appbtnBarButton' : 'appbtn-engage disabledSkybluebtn-engage appbtnBarButton'}>
                                                            Message
                                                        </Grid>
                                                        <Grid id='device_btn_unregisterdevice' onClick={this.Unregister}
                                                            className={(options.isUpdateDevice || options.selectedDevices.length > 0) ? 'appbtn-engage-yellow appbtn-engage appbtnBarButton' : 'appbtn-engage disabledSkybluebtn-engage appbtnBarButton'}>
                                                            Unregister
                                                        </Grid>
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                            : options.openCommunitySettings ?
                                                <React.Fragment>
                                                    <Grid item container justifyContent='flex-end' alignContent='center'>
                                                        <Grid id='settings_btn_save' className="appbtnBarButtonv2 greenbtn-engage" onClick={this.handlerSaveClick} style={{ marginLeft: '5px', marginRight: '5px' }}>
                                                            Save
                                                        </Grid>
                                                        <Grid id='home_tiles_tv' className="appbtnBarButtonv2 blueButton" onClick={this.handlerHomeTiles} style={{ marginLeft: '5px', marginRight: '5px' }}>
                                                            Home TV Tiles
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                                : !options.isUpdResident ?
                                                    <React.Fragment>
                                                        <Grid
                                                            id='resident_btn_newResident'
                                                            className={(options.communityExists === false) ? 'appbtn-engage disabledPurplebtn-engage appbtnBarButton' : 'appbtn-engage purplebtn-engage appbtnBarButton'}
                                                            onClick={options.communityExists === false ? undefined : this.NewResident}
                                                        >
                                                            {windowWidth <= 600 ? 'New' : 'New Resident'}
                                                        </Grid>
                                                        <Grid
                                                            id='resident_btn_connectInvitation'
                                                            className={'appbtn-engage skybluebtn-engage appbtnBarButton'}
                                                            onClick={options.communityExists === false ? undefined : this.openInvitationModal}
                                                        >
                                                            Invite Family Member
                                                        </Grid>
                                                        <Grid
                                                            id='resident_btn_sync_residents'
                                                            className={'appbtn-engage skybluebtn-engage appbtnBarButton'}
                                                            onClick={this.SyncResidents}
                                                        >
                                                            Sync Residents
                                                        </Grid>

                                                        {/*<div  className='appbtn-engage redbtn-engage' onClick={this.CancelResident}>
                                        Cancel
                                    </div>*/}
                                                    </React.Fragment>
                                                    :
                                                    options.isUpdResident ?
                                                        <React.Fragment>
                                                            <Grid id='resident_update_btn_deleteResident' className='appbtn-engage redbtn2-engage appbtnBarButton' onClick={this.DeleteResident}>
                                                                {windowWidth <= 1024 ? 'Delete' : 'Delete Resident'}
                                                            </Grid>
                                                            <Grid id='resident_update_btn_saveResident' className='appbtn-engage appbtnBarButton'
                                                                style={(options.onErrorSelectedResidentFirstName || options.onErrorSelectedResidentLastName) ? { backgroundColor: '#ffffff', color: '#bdbdbd' } : { backgroundColor: '#009EDD' }}
                                                                disabled={(options.onErrorSelectedResidentFirstName || options.onErrorSelectedResidentLastName)}
                                                                onClick={this.EditResident}>
                                                                {windowWidth <= 1024 ? 'Save' : 'Save Resident'}


                                                            </Grid>
                                                            <Grid
                                                                id='resident_update_btn_connectInvitation'
                                                                className={'appbtn-engage skybluebtn-engage appbtnBarButton'}
                                                                onClick={this.state.communityExists === false ? undefined : this.openInvitationModal}
                                                            >
                                                                Invite Family Member
                                                            </Grid>
                                                            {/*<div  className='appbtn-engage redbtn-engage'>
                                        Cancel
                                    </div>*/}
                                                        </React.Fragment>
                                                        :
                                                        undefined
                                }

                            </div>
                    }
                </div>
                :
                undefined
        )
    };

    resize() {
        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 960,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1280,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidth = window.innerWidth;

        let rootFontSize = sizes.xs;

        if (windowWidth > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidth > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidth > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({ rootFontSize: rootFontSize },
            //     this.SetHeaderButtons(
            //         {
            //             openResident: this.state.openResident,
            //             openCommunity: this.state.openCommunity,
            //             openDevice: this.state.openDevice,
            //             openCommunitySettings: this.state.oppenCommunitySettings,
            //             isUpdateDevice: this.state.isUpdateDevice,            
            //             isUpdResident:this.state.isUpdResident,
            //             communityExists:this.state.communityExists,
            //             onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
            //             onErrorSelectedResidentLastName:this.state.onErrorSelectedResidentLastName,
            //             communitySelected: this.state.communitySelected,
            //             community: this.state.communitySelected,
            //             method: 'resize',
            //         }
            //     )
        );
    };

    GetAllCommunities = async () => {
        if (localStorage.getItem('superAdmin') === "false") {
            //this.props.getCommunityById(localStorage.getItem('communityId'))
            let community = await this.props.getCommunityByIdAsync(localStorage.getItem('communityId'));
            this.setState({ communitySelected: community[0] });
        }
        else {
            this.props.getAllCommunities();

            if (this.state.communitySelected !== undefined) {
                let community = await this.props.getCommunityByIdAsync(localStorage.getItem('communityId'));
                this.setState({ communitySelected: community[0] });
                this.SetHeaderButtons(
                    {
                        openResident: this.state.openResident,
                        openCommunity: this.state.openCommunity,
                        openDevice: this.state.openDevice,
                        isUpdateDevice: this.state.isUpdateDevice,
                        isUpdResident: this.state.isUpdResident,
                        selectedDevices: this.state.selectedDevices,
                        communityExists: this.state.communityExists,
                        onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                        onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                        communitySelected: community[0]
                    }
                )

                //this.setState({ communitySelected: this.props.tableData.find( item => item.communityId === localStorage.getItem('communityId'))});
            }
        }

    };

    handleIsUpdateDevice = (isUpdateDevice = false, deviceSelected = undefined, selectedDevices = []) => {

        this.setState((prevState) => ({ isUpdateDevice: isUpdateDevice, deviceSelected: deviceSelected }));

        this.SetHeaderButtons({
            openResident: this.state.openResident,
            openCommunity: this.state.openCommunity,
            openDevice: this.state.openDevice,
            openCommunitySettings: this.state.oppenCommunitySettings,
            isUpdateDevice: isUpdateDevice,
            selectedDevices: this.state.selectedDevices,
            isUpdResident: this.state.isUpdResident,
            communityExists: this.state.communityExists,
            onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
            onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
        });
    }

    handleIsSelectedDevices = (selectedDevices = []) => {

        this.setState({ selectedDevices: selectedDevices }, () => {
            this.SetHeaderButtons(
                {
                    openResident: this.state.openResident,
                    openCommunity: this.state.openCommunity,
                    openDevice: this.state.openDevice,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName
                }
            )
        });


    }

    handleDelete = (e, data, index) => {

        Alert.warning('Are you sure you want to delete the community?', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
                displayComponent: true,
                handleButtonClick: this.deleteCommunity,
                id: data,
            },
        });

    }

    handleSettingsClick = () => {


        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ openCommunitySettings: true },

            this.SetHeaderButtons(
                {
                    openResident: this.state.openResident,
                    openCommunity: this.state.openCommunity,
                    openDevice: this.state.openDevice,
                    openCommunitySettings: true,
                    isUpdateDevice: this.state.isUpdateDevice,
                    selectedDevices: this.state.selectedDevices,
                    isUpdResident: this.state.isUpdResident,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );

    }

    deleteCommunity = (event, item, isActive) => {

        if (item._id) {
            //Call delete Community
            this.props.delCommunity(item);
        }

        const lastPage = Math.ceil((this.props.tableData.length - 1) / this.state.itemPerPage);

        if (this.state.currentPage > lastPage) {
            this.handlePageChange(lastPage);
        }

        Alert.closeAll();
    };

    handleaddAdd = () => {

        this.setState({ openCommunity: true, community: '', isAddCommunity: true },
            this.SetHeaderButtons(
                {
                    openResident: this.state.openResident,
                    openCommunity: true,
                    openDevice: this.state.openDevice,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    selectedDevices: this.state.selectedDevices,
                    isUpdResident: this.state.isUpdResident,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        )


    };

    CancelCommunity = () => {
        var link = document.getElementById('cancel_btn')
        link.click()

        this.GetAllCommunities();
        this.props.ClearVersions();

        this.props.ClearDevices();
        this.handleIsSelectedDevices([])
    };

    SaveCommunity = () => {
        var link = document.getElementById('save_btn')
        link.click();

        setTimeout(() => {
            this.GetAllCommunities();
        }, 500);

    };

    handleClose = (pageNextItem = 0) => {
        document.title = 'Community'

        this.setState({ openCommunity: false, openResident: false, reverseResident: false, isUpdResident: false, openDevice: false, isUpdateDevice: false, openCommunitySettings: false, residentFiltersOpen: false, openNewLocation: false },
            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: false,
                    isUpdResident: false,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );



        if (pageNextItem > 0) {
            this.handlePageChange(pageNextItem);
        }

        setTimeout(() => {
            this.GetAllCommunities();
        }, 600);
    };

    handlePageChange = (number) => {

        if (number && typeof (number) == 'number' && number > 0) {
            this.setState({
                currentPage: Number(number)
            });
        }

    };


    //Residents
    NewResident = () => {
        var link = document.getElementById('new_resident_btn')
        link.click()
    };

    DeleteResident = () => {
        var link = document.getElementById('delete_resident_btn')
        link.click()
    };

    EditResident = () => {
        if (!(this.state.onErrorSelectedResidentFirstName || this.state.onErrorSelectedResidentLastName)) {
            var link = document.getElementById('edit_resident_btn')
            link.click()
        }
    };

    CancelResident = () => {
        var link = document.getElementById('cancel_resident_btn')
        link.click()
    };

    //Connect Invitation Modal
    openInvitationModal = () => {
        var link = document.getElementById('open_Invitation_Modal_btn')
        link.click();
    }

    // Sync Residents From CL
    SyncResidents = () => {
        var link = document.getElementById('sync_Residents_Modal_btn')
        link.click();
    }
    //endResidents

    //Devices
    NewDevice = () => {
        var link = document.getElementById('new_device_btn')
        link.click()
    };

    ExportDevice = () => {
        var link = document.getElementById('export_device_btn')
        link.click()
    };

    Message = () => {
        if (this.state.selectedDevices.length > 0 || this.state.isUpdateDevice) {
            var link = document.getElementById('message_btn')
            link.click()
        }
    };

    Unregister = () => {
        if (this.state.selectedDevices.length > 0 || this.state.isUpdateDevice) {
            var link = document.getElementById('unregister_btn')
            link.click()
        }
    };

    Reboot = () => {
        if (this.state.selectedDevices.length > 0 || this.state.isUpdateDevice) {
            var link = document.getElementById('reboot_btn')
            link.click()
        }
    }

    SaveDevice = () => {
        var link = document.getElementById('save_device_btn')
        link.click()
    };

    EditDevice = () => {
        var link = document.getElementById('update_device_btn')
        link.click()

    }

    CancelEditDevice = () => {
        var link = document.getElementById('cancel_device_btn');
        link.click();
    }
    //endDevices


    divSetUp = async () => {
        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }
        const communityId = localStorage.getItem('communityId');

        const communityInfo = await this.props.getCommunityByIdAsync(communityId);

        this.setState({ community: communityInfo[0], openCommunity: true, openResident: true, openDevice: false },

            this.SetHeaderButtons(
                {
                    openResident: true,
                    openCommunity: true,
                    openDevice: false,
                    openApps: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );


    }

    divResident = () => {
        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: true, openDevice: false, communityExist: true },

            this.SetHeaderButtons(
                {
                    openResident: true,
                    openCommunity: false,
                    openDevice: false,
                    openApps: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );

    }

    divDevice = () => {
        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: true },
            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: true,
                    openApps: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );

    }

    LocationClick = () => {

        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: true },

            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openApps: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );
    };

    newLocationClick = () => {

        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: false, openNewLocation: true },

            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );
    };


    divApps = () => {

        if (!this.state.communitySelected) {
            sweetAlert('error', 'You must select a community ', 'alert_CommunityV2_SelectCommunity_Error');
            return;
        }

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: false, openApps: true },

            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openApps: true,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );
    };

    handleCommunityExist(communityExist) {
        this.setState({ communityExists: communityExist },

            this.SetHeaderButtons(
                {
                    openResident: this.state.openResident,
                    openCommunity: this.state.openCommunity,
                    openDevice: this.state.openDevice,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: communityExist,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );

    }


    async GetCommunityById(communityObj) {
        const communityId = (communityObj && communityObj.communityId) ? communityObj.communityId : undefined;
        let communityDetails = communityObj;

        if (communityId) {
            let communityD = undefined;
            communityD = await this.props.getCommunityByIdAsync(communityId);
            communityDetails = (communityD && communityD.length > 0 && communityD[0].communityId) ? communityD[0] : communityObj;

        }

        return communityDetails;
    }

    inputHidden = {
        display: 'none'
        // displayComponent: 'none'
    }

    GetCommunityObjectForSupuerUserCombo(communityId) {
        let communityObj = null;
        if (this.props.tableData) {

            communityObj = this.props.tableData.find(item => item.communityId === communityId);
        }

        return communityObj;
    };

    readImage(e, imageName) {
        //Base 64

        let community = this.state.communitySelected;
        let reader = new FileReader();
        const imageSelected = e.target.files[0]

        if (imageSelected === undefined)
            return;

        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
            const objBase64 = {
                type: imageSelected.type,
                name: imageSelected.name.replace(/[:/#?&@%+~\s]/g, '_'),
                file: reader.result

            }

            switch (imageName) {
                case 'communityImage':
                    this.setState({ selectedCommunityImage: URL.createObjectURL(imageSelected), objBase64selectedCommunityImage: objBase64 });
                    break;
                default:
                    break;
            }

            this.UpdateImageOnServer(community.communityId, objBase64);
        }
    };

    UpdateImageOnServer = (communityId, objBase64Image) => {

        if (!communityId || !objBase64Image)
            return

        this.props.UpdateCommuntyImage(communityId, objBase64Image);

        setTimeout(() => {
            this.props.getAllCommunities();
        }, 600);

    };


    handleCommunitySelectClick = (event) => {

        let currentTarget = event.currentTarget;

        const isOpen = this.state.communitySelectOpen ? this.state.communitySelectOpen : false;

        if (!isOpen) {
            this.setState((prevState) => ({ communitySelectOpen: true, anchorEl: currentTarget }))
        }

        // this.setState((prevState) => ({communitySelectOpen: !prevState.communitySelectOpen, anchorEl:currentTarget }))
    };

    handleCommunitySettingsClose = () => {
        this.setState({ openCommunitySettings: false },

            this.SetHeaderButtons(
                {
                    openResident: this.state.openResident,
                    openCommunity: this.state.openCommunity,
                    openDevice: this.state.openDevice,
                    openCommunitySettings: false,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                    communitySelected: this.state.communitySelected,
                }
            )
        );

        document.title = 'Community'

    };


    handlerOnLocationsClose = () => {

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: false },

            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openCommunitySettings: this.state.oppenCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                }
            )
        );
    };

    //#region HANDLERS
    handlerOpenElementDetails = (CurrentElement) => {
        this.setState({
            elementDetailsOpen: CurrentElement,
        });

    };

    handlerCloseElementDetails = () => {

        const CurrentElement = this.state?.elementDetailsOpen;
        var link;

        switch (CurrentElement) {
            case 'room':
                link = document.getElementById('cancel_btn_rooms');
                link.click();
                break;
            case 'item':
                link = document.getElementById('cancel_btn_items');
                link.click();
                break;
            case 'issue':
                link = document.getElementById('cancel_btn_issues');
                link.click();
                break;
            default:
                break;
        }

        this.handlerOpenElementDetails(undefined);

    }
    //#endregion


    handlerOnLocationsClose = () => {

        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: false, openNewLocation: false },


            this.SetHeaderButtons(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openCommunitySettings: this.state.openCommunitySettings,
                    isUpdateDevice: this.state.isUpdateDevice,
                    isUpdResident: this.state.isUpdResident,
                    selectedDevices: this.state.selectedDevices,
                    communityExists: this.state.communityExists,
                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                    communitySelected: this.state.communitySelected,
                }
            )
        );

        document.title = 'Community'

    };

    handlerOnAppsViewClose = () => {
        this.setState({ community: this.state.communitySelected, openCommunity: false, openResident: false, openDevice: false, openLocation: false, openApps: false });

        this.SetHeaderButtons(
            {
                openResident: false,
                openCommunity: false,
                openDevice: false,
                openCommunitySettings: this.state.openCommunitySettings,
                isUpdateDevice: this.state.isUpdateDevice,
                isUpdResident: this.state.isUpdResident,
                selectedDevices: this.state.selectedDevices,
                communityExists: this.state.communityExists,
                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                communitySelected: this.state.communitySelected,
            }
        )
    };



    //#region Inner Components
    ActionsComponent = () => {
        let isSuperUser = localStorage.getItem('superAdmin');

        isSuperUser = isSuperUser === 'true';

        let justifyContentClass = 'center';
        let lgColumns = 3;
        let mdColumns = 3;
        let sectionGrid = 8;

        if (isSuperUser) {
            justifyContentClass = 'space-around';
            lgColumns = 2;
            mdColumns = 2;
            sectionGrid = 10;
        }

        return (

            <Grid item container xs={12} spacing={2} justifyContent={justifyContentClass} alignItems='space-arround'>
                {isSuperUser === true ?
                    <>
                        <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                            <Grid item xs={sectionGrid} onClick={this.handleSettingsClick} style={this.objStyles.GridSection}>
                                <Grid id='community_options_settings' container direction='column' style={this.objStyles.GridColum}>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Community/cogs.svg'
                                            alt='settings'
                                            id='settingsImg'
                                            style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <span>Settings</span>
                                    </Grid>
                                </Grid>
                                <Grid item container justifyContent='center'>
                                    <Grid item xs={10}>
                                        <h5 id='communityPage_Options_Settings' className='communityActionDescription' >Manage Home tiles available for Residents or community</h5>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* 
                        <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                            <Grid item xs={sectionGrid} onClick={this.divApps} style={this.objStyles.GridSection}>
                                <Grid id='community_options_setUp' container direction='column' style={this.objStyles.GridColum}>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Community/cogs.svg'
                                            alt='new Settings'
                                            id='newSettings'
                                            style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <span>New Settings</span>
                                    </Grid>
                                </Grid>
                                <Grid item container justifyContent='center'>
                                    <Grid item xs={10}>
                                        <h5 id='communityPage_Options_SetUp' className='communityActionDescription' >Manage Home tiles available for Residents or community</h5>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        */}
                        <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                            <Grid item xs={sectionGrid} onClick={this.divSetUp} style={this.objStyles.GridSection}>
                                <Grid id='community_options_setUp' container direction='column' style={this.objStyles.GridColum}>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Community/tools.svg'
                                            alt='resident'
                                            id='userPictureImg'
                                            style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                        <span>Set Up</span>
                                    </Grid>
                                </Grid>
                                <Grid item container justifyContent='center'>
                                    <Grid item xs={10}>
                                        <h5 id='communityPage_Options_SetUp' className='communityActionDescription' >Manage the community and its integrations</h5>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                    : ""
                }
                <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                    <Grid item xs={sectionGrid} onClick={this.divResident} style={this.objStyles.GridSection}>
                        <Grid id='community_options_residents' container direction='column' style={this.objStyles.GridColum}>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <img
                                    src='https://engage360.s3.amazonaws.com/Icons/Community/users.svg'
                                    alt='resident'
                                    id='userPictureImg'
                                    style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <span>Residents</span>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent='center'>
                            <Grid item xs={10}>
                                <h5 id='communityPage_Options_residents' className='communityActionDescription' >Manage residents and their locations</h5>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                    <Grid item xs={sectionGrid} onClick={this.divDevice} style={this.objStyles.GridSection}>
                        <Grid id='community_options_devices' container direction='column' style={this.objStyles.GridColum}>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <img
                                    src='https://engage360.s3.amazonaws.com/Icons/Community/hdd.svg'
                                    alt='resident'
                                    id='userPictureImg'
                                    style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <span>Devices</span>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent='center'>
                            <Grid item xs={10}>
                                <h5 id='communityPage_Options_devices' className='communityActionDescription' >Manage eHubs and their locations</h5>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                    <Grid item xs={sectionGrid} onClick={this.LocationClick} style={this.objStyles.GridSection}>
                        <Grid id='community_options_locations' container direction='column' style={this.objStyles.GridColum} >
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <img
                                    src='https://engage360.s3.amazonaws.com/Icons/Community/map-marker-alt.svg'
                                    alt='resident'
                                    id='userPictureImg'
                                    style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <span>Locations</span>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent='center'>
                            <Grid item xs={10}>
                                <h5 id='communityPage_Options_Locations' className='communityActionDescription' >Manage Rooms, Items and Issues</h5>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/*
                <Grid item xs={12} sm={12} md={mdColumns} lg={lgColumns}>
                    <Grid item xs={sectionGrid} onClick={this.newLocationClick} style={this.objStyles.GridSection}>
                        <Grid id='community_options_locations' container direction='column' style={this.objStyles.GridColum} >
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <img
                                    src='https://engage360.s3.amazonaws.com/Icons/Community/map-marker-alt.svg'
                                    alt='locations'
                                    id='newLocationsBtn'
                                    style={{ width: '75px', height: '75px', paddingTop: '15px' }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: 'center', alignContent: 'center', paddingBottom: '10px' }}>
                                <span>New Locations</span>
                            </Grid>
                        </Grid>
                        <Grid item container justifyContent='center'>
                            <Grid item xs={10}>
                                <h5 id='communityPage_Options_Locations' className='communityActionDescription' >Manage Apartments, Rooms, Items and Issues (Beta)</h5>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                */}
            </Grid>
        )
    };

    sortIconClick = () => {
        this.setState((prevState) => ({ reverseResident: !prevState.reverseResident }));
        const link = document.getElementById("sort_residents_btn");
        link.click();
    }
    handleFilterClick = () => {
        this.setState((prevState) => ({
            residentFiltersOpen: !prevState.residentFiltersOpen,
            residentsFiltersAnchorElId: 'filtersButton'

        }),
            () => {
                const link = document.getElementById('filters_btn');
                link.click();
            });

    }


    handleDeviceFiltersClick = () => {
        this.setState((prevState) => ({
            deviceFiltersOpen: !prevState.deviceFiltersOpen,
            deviceFiltersAnchorElId: 'DeviceFiltersButton'

        }),
            () => {
                const link = document.getElementById('device_filters_btn');
                link.click();
            });

    }

    getLastConnectionWithinUmbral = (lastConnectionDate = undefined) => {

        const now = new Date();
        const lastConn = new Date(lastConnectionDate);

        if (!lastConnectionDate || isNaN(lastConn.getTime()))
            return false;

        const umbralInMinutes = (this.state.umbralInMinutes && this.state.umbralInMinutes > 0) ? this.state.umbralInMinutes : 5;;
        const lastConnectionWithinUmbral = (umbralInMinutes * 60 * 1000) > (now.getTime() - lastConn.getTime());

        return lastConnectionWithinUmbral;
    }

    AppBarContainer = () => {
        return (
            <AppBar position="static" className="dark">
                <Toolbar>
                    <Grid item container xs={12}>
                        <Grid item container xs={12} md={8} lg={6} alignContent='center' justifyContent='flex-start' >
                            {
                                this.state.isUpdResident ?
                                    <Typography variant="h6" >
                                        <div id='community_chevronlist_updateResident' className="engage-nav ToolbalCommunityName" onClick={this.CancelResident}>
                                            <img
                                                src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                alt='return'
                                                className="returnIcon"
                                            />
                                            {
                                                !this.state.openResident && !this.state.openCommunity && !this.state.openDevice ? '' : this.state.community.communityName + ' Resident'
                                            }
                                        </div>
                                    </Typography>
                                    :
                                    this.state.isUpdateDevice ?
                                        <Typography variant="h6" >
                                            <div id='community_chevronlist_updateDevice' className="engage-nav ToolbalCommunityName" onClick={this.CancelEditDevice}>
                                                <img
                                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                    alt='return'
                                                    className="returnIcon"
                                                />
                                                {
                                                    !this.state.openResident && !this.state.openCommunity && this.state.isUpdateDevice ? this.state.community.communityName + ' Devices' : ''
                                                }
                                            </div>
                                        </Typography>
                                        :
                                        this.state.openCommunitySettings ?
                                            <Typography variant="h6"  >
                                                <div id='community_chevronlist_communitySettings' className="engage-nav ToolbalCommunityName" onClick={this.handleCommunitySettingsClose}>
                                                    <img
                                                        src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                        alt='return'
                                                        className="returnIcon"
                                                    />
                                                    {
                                                        (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName : ''
                                                    }
                                                </div>
                                            </Typography>
                                            : //Rooms
                                            this.state.openLocation && (this.state.elementDetailsOpen && this.state.elementDetailsOpen === 'room') ?
                                                <Typography variant="h6"  >
                                                    <div id='community_chevronlist_location_room' className="engage-nav ToolbalCommunityName" onClick={() => this.handlerCloseElementDetails('room')}>
                                                        <img
                                                            src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                            alt='return'
                                                            className="returnIcon"
                                                        />
                                                        {
                                                            (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName + ' Rooms' : ''
                                                        }
                                                    </div>
                                                </Typography>
                                                : // Items
                                                this.state.openLocation && (this.state.elementDetailsOpen && this.state.elementDetailsOpen === 'item') ?
                                                    <Typography variant="h6">
                                                        <div id='community_chevronlist_location_item' className="engage-nav ToolbalCommunityName" onClick={() => this.handlerCloseElementDetails('item')}>
                                                            <img
                                                                src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                                alt='return'
                                                                className="returnIcon"
                                                            />
                                                            {
                                                                (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName + ' Items' : ''
                                                            }
                                                        </div>
                                                    </Typography>
                                                    : // Issues
                                                    this.state.openLocation && (this.state.elementDetailsOpen && this.state.elementDetailsOpen === 'issue') ?
                                                        <Typography variant="h6"  >
                                                            <div id='community_chevronlist_location_issues' className="engage-nav ToolbalCommunityName" onClick={() => this.handlerCloseElementDetails('issue')}>
                                                                <img
                                                                    src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                                    alt='return'
                                                                    className="returnIcon"
                                                                />
                                                                {
                                                                    (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName + ' Issues' : ''
                                                                }
                                                            </div>
                                                        </Typography>
                                                        :
                                                        this.state.openLocation || this.state.openNewLocation ?
                                                            <Typography variant="h6" >
                                                                <div id='community_chevronlist_location' className="engage-nav ToolbalCommunityName" onClick={this.handlerOnLocationsClose}>
                                                                    <img
                                                                        src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                                        alt='return'
                                                                        className="returnIcon"
                                                                    />
                                                                    {
                                                                        (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName : ''
                                                                    }
                                                                </div>
                                                            </Typography>
                                                            //     :
                                                            //     this.state.openApps?
                                                            //     <Typography variant="h6" >
                                                            //     <div id='community_chevronlist_location' className="engage-nav ToolbalCommunityName" onClick={this.handlerOnAppsViewClose}>
                                                            //         <img
                                                            //             src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                            //             alt='return'
                                                            //             className="returnIcon"
                                                            //         />
                                                            //         {
                                                            //             (this.state.communitySelected && this.state.communitySelected.communityName) ? this.state.communitySelected.communityName : ''
                                                            //         }
                                                            //     </div>
                                                            // </Typography>
                                                            :
                                                            this.state.openCommunity || this.state.openResident || this.state.openDevice ?
                                                                <Typography variant="h6" >
                                                                    <div id='community_chevronlist' className="engage-nav ToolbalCommunityName" onClick={this.CancelCommunity}>
                                                                        <img
                                                                            src='https://engage360.s3.amazonaws.com/Icons/chevron-circle-left.svg'
                                                                            alt='return'
                                                                            className="returnIcon"
                                                                        />
                                                                        {
                                                                            !this.state.openResident && !this.state.openCommunity && !this.state.openDevice ? '' : this.state.community.communityName
                                                                        }
                                                                    </div>
                                                                </Typography>
                                                                :
                                                                ""

                            }
                        </Grid>
                        <Grid item container xs={12} sm={4} md={4} lg={6} justifyContent='flex-end'>
                            {
                                this.state.isUpdateDevice ?
                                    <Grid item container justifyContent='flex-end' >
                                        <Grid item style={{ margin: '0 5px', marginRight: '15px' }}>
                                            <FontAwesomeIcon
                                                className="icon-menu-size"
                                                icon={faClipboardList}
                                                style={{ color: this.state.deviceSelected?.active ? '#5BDB86' : '#959494', }}
                                            />
                                        </Grid>
                                        <Grid item style={{ margin: '0 5px' }}>
                                            <FontAwesomeIcon
                                                className="icon-menu-size"
                                                icon={faGlobe}
                                                style={{ color: this.getLastConnectionWithinUmbral(this.state.deviceSelected.lastConnectionDate) ? '#5BDB86' : '#959494', }}
                                            />
                                        </Grid>
                                    </Grid>
                                    :
                                    !this.state.openCommunity && !this.state.openDevice && !this.state.isUpdResident && this.state.openResident ?
                                        <Grid item container justifyContent='flex-end'>

                                            <IconButton onClick={this.handleFilterClick} id='filtersButton'>
                                                <FontAwesomeIcon
                                                    icon={this.state.residentFiltersOpen === false ? faFilter : faTimesCircle}
                                                    color='white'
                                                    style={{ opacity: '56%' }}
                                                    size='lg'
                                                />
                                            </IconButton>
                                            <IconButton onClick={this.sortIconClick} id='Residents_Sort_Button'>
                                                <FontAwesomeIcon
                                                    icon={this.state.reverseResident === false ? faSortAmountDown : faSortAmountUpAlt}
                                                    color='white'
                                                    style={{ opacity: '56%' }}
                                                    size='lg'
                                                />
                                            </IconButton>
                                        </Grid>

                                        :
                                        !this.state.openCommunity && !this.state.isUpdResident && !this.state.openResident && this.state.openDevice ?
                                            <Grid item container justifyContent='flex-end'>

                                                <IconButton item onClick={this.handleDeviceFiltersClick} id='DeviceFiltersButton'>
                                                    <FontAwesomeIcon
                                                        icon={this.state.deviceFiltersOpen === false ? faFilter : faTimesCircle}
                                                        color='white'
                                                        style={{ opacity: '56%' }}
                                                        size='lg'
                                                    />
                                                </IconButton>
                                                {/* <IconButton item onClick={this.sortIconClick}>
                                <FontAwesomeIcon
                                    icon={this.state.reverseResident===false? faSortAmountDown:faSortAmountUpAlt}
                                    color='white'
                                    style={{opacity:'56%'}}
                                    size='lg'
                                />
                            </IconButton> */}
                                            </Grid>
                                            :
                                            undefined
                            }
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        )
    };


    CommunityComponent = () => {
        const viewPort = (this.state.rootFontSize && this.state.rootFontSize.name) ? this.state.rootFontSize.name : 'md';
        return (
            //()=>{  this.state.communitySelectOpen==true && this.setState({communitySelectOpen:false})}
            <Grid xs={12} sm={12} md={12} lg={6} item container justifyContent='center' alignItems='center' onBlur={() => this.setState({ communitySelectOpen: false })}>
                <Grid item xs={12} onClick={this.handleCommunitySelectClick} id='communitySelect' >
                    {
                        <Grid item container xs={12} style={{ paddingLeft: '15px', marginRight: '15px', height: '39px' }} justifyContent='flex-start'>
                            {localStorage.getItem('superAdmin') === "true" ?
                                <CommunitySelect
                                    //    inputClassName = 'communitySelectStyles'
                                    //     inputStyle={{color:'#F0EFEF', fontSize:'32px', fontFamily:'Gotham-Bold'}}
                                    id='Community_communitySelect'
                                    label={'Community'}
                                    open={this.state.communitySelectOpen}
                                    anchorEl={this.state.anchorEl}
                                    onChangeHandler={
                                        (evet, newItem) => {

                                            if (newItem !== null && newItem !== '') {
                                                localStorage.setItem('communityId', newItem.communityId);
                                                this.setState({ communitySelected: newItem, selectedCommunityImage: newItem.communityLogoUrl, communitySelectOpen: false }
                                                    ,
                                                    this.SetHeaderButtons(
                                                        {
                                                            openResident: this.state.openResident,
                                                            openCommunity: this.state.openCommunity,
                                                            openDevice: this.state.openDevice,
                                                            openCommunitySettings: this.state.oppenCommunitySettings,
                                                            isUpdateDevice: this.state.isUpdateDevice,
                                                            isUpdResident: this.state.isUpdResident,
                                                            selectedDevices: this.state.selectedDevices,
                                                            communityExists: this.state.communityExists,
                                                            onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                            onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                            communitySelected: newItem,
                                                            community: newItem
                                                        }
                                                    )
                                                );

                                                this.GetAllCommunities();

                                                this.props.ClearVersions();
                                                this.props.ClearDevices();

                                                this.SetHeaderButtons(
                                                    {
                                                        openResident: this.state.openResident,
                                                        openCommunity: this.state.openCommunity,
                                                        openDevice: this.state.openDevice,
                                                        isUpdateDevice: this.state.isUpdateDevice,
                                                        isUpdResident: this.state.isUpdResident,
                                                        selectedDevices: this.state.selectedDevices,
                                                        communityExists: this.state.communityExists,
                                                        onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                        onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                        communitySelected: newItem,
                                                    }
                                                )


                                            } else {
                                                this.setState({ communitySelected: undefined, selectedCommunityImage: undefined, objBase64selectedCommunityImage: undefined, communitySelectOpen: true },
                                                    this.SetHeaderButtons(
                                                        {
                                                            openResident: this.state.openResident,
                                                            openCommunity: this.state.openCommunity,
                                                            openDevice: this.state.openDevice,
                                                            openCommunitySettings: this.state.oppenCommunitySettings,
                                                            isUpdateDevice: this.state.isUpdateDevice,
                                                            isUpdResident: this.state.isUpdResident,
                                                            selectedDevices: this.state.selectedDevices,
                                                            communityExists: this.state.communityExists,
                                                            onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                            onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                            communitySelected: undefined,
                                                        }
                                                    )
                                                );
                                                localStorage.removeItem('communityId');
                                                this.SetHeaderButtons(
                                                    {
                                                        openResident: this.state.openResident,
                                                        openCommunity: this.state.openCommunity,
                                                        openDevice: this.state.openDevice,
                                                        isUpdateDevice: this.state.isUpdateDevice,
                                                        isUpdResident: this.state.isUpdResident,
                                                        selectedDevices: this.state.selectedDevices,
                                                        communityExists: this.state.communityExists,
                                                        onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                        onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                        communitySelected: undefined
                                                    }
                                                )
                                            }

                                        }
                                    }
                                    optionsItemsIconsData={this.props.tableData ? this.props.tableData : []}
                                    selected={this.state.communitySelected ? this.state.communitySelected : {}}
                                    disabled={false}
                                />
                                :
                                <Grid>
                                    <h2 style={{ ...this.objStyles.TitleSection }}>{this.state.communitySelected ? this.state.communitySelected.communityName : ""}</h2>
                                </Grid>
                            }
                        </Grid>

                    }
                </Grid>
                {localStorage.getItem('superAdmin') === "true" ?
                    <Grid item container xs={12} direction='row' style={{ height: '15rem', marginTop: '15px' }}>
                        <Grid item container xs={12}>
                            <Grid item container xs={12} className='communityInfo' direction='column' alignItems='flex-start' justifyContent='space-around'>
                                <Grid item container>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 4 : 2} style={{ textAlign: "left" }}>
                                        Address:
                                    </Grid>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 8 : 10} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                        {
                                            this.state.communitySelected ? this.state.communitySelected.communityAddress : ""
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 4 : 2} style={{ textAlign: "left" }}>
                                        City:
                                    </Grid>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 8 : 10} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                        {
                                            this.state.communitySelected ? this.state.communitySelected.communityCity : ""
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 4 : 2} style={{ textAlign: "left" }}>
                                        State:
                                    </Grid>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 8 : 10} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                        {
                                            this.state.communitySelected ? this.state.communitySelected.communityState : ""
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 4 : 2} style={{ textAlign: "left" }}>
                                        Zip Code:
                                    </Grid>
                                    <Grid item xs={(viewPort === 'xs' || viewPort === 'sm') ? 8 : 10} style={{ color: '#F0EFEF', fontWeight: 200, textAlign: "left" }}>
                                        {
                                            this.state.communitySelected ? this.state.communitySelected.communityZipcode.toString().padStart(5, '0') : ""
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    : ""
                }
            </Grid>
        )
    }
    //#endregion


    enableSyncButton = () => {
        const communityId = localStorage.getItem('communityId');
        const objCommunity = this.GetCommunityObjectForSupuerUserCombo(communityId);
        this.setState({ enableCLSyncButton: true }, () => this.SetHeaderButtons(
            {
                openResident: this.state.openResident,
                openCommunity: this.state.openCommunity,
                openDevice: this.state.openDevice,
                openCommunitySettings: this.state.oppenCommunitySettings,
                isUpdateDevice: this.state.isUpdateDevice,
                isUpdResident: this.state.isUpdResident,
                selectedDevices: this.state.selectedDevices,
                communityExists: this.state.communityExists,
                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                communitySelected: objCommunity,
                community: objCommunity,
            }
        ))
    }
    disableSyncButton = () => {
        const communityId = localStorage.getItem('communityId');
        const objCommunity = this.GetCommunityObjectForSupuerUserCombo(communityId);
        this.setState({ enableCLSyncButton: false }, () => this.SetHeaderButtons(
            {
                openResident: this.state.openResident,
                openCommunity: this.state.openCommunity,
                openDevice: this.state.openDevice,
                openCommunitySettings: this.state.oppenCommunitySettings,
                isUpdateDevice: this.state.isUpdateDevice,
                isUpdResident: this.state.isUpdResident,
                selectedDevices: this.state.selectedDevices,
                communityExists: this.state.communityExists,
                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                communitySelected: objCommunity,
                community: objCommunity,
            }
        ))
    }

    OnCancelHandler = () => {
        this.setState({ showModalSyncCL: false });
    };

    OnSyncCLCommunity = () => {
        const communityId = localStorage.getItem('communityId');
        const objCommunity = this.GetCommunityObjectForSupuerUserCombo(communityId);

        var link = document.getElementById('sync_community_btn')
        link.click();


        this.setState({ showModalSyncCL: false, enableCLSyncButton: false }, () => this.SetHeaderButtons(
            {
                openResident: this.state.openResident,
                openCommunity: this.state.openCommunity,
                openDevice: this.state.openDevice,
                openCommunitySettings: this.state.oppenCommunitySettings,
                isUpdateDevice: this.state.isUpdateDevice,
                isUpdResident: this.state.isUpdResident,
                selectedDevices: this.state.selectedDevices,
                communityExists: this.state.communityExists,
                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                communitySelected: objCommunity,
                community: objCommunity,
            }
        ));
    }

    SyncCLCommunity = () => {
        if (this.state.enableCLSyncButton)
            this.setState({ showModalSyncCL: true })
    }

    render() {

        const shouldReturnToHome = (this.props.returnToHome && this.props.returnToHome === 'true') ? true : false;
        if (this.props.UpdateCurrentLocation && shouldReturnToHome) {

            this.setState(
                {
                    openResident: false,
                    openCommunity: false,
                    openDevice: false,
                    openCommunitySettings: false,
                    openApps: false,
                    openNewLocation: false,
                    openLocation: false
                },
                () => {
                    this.InitialLoading();
                    this.props.UpdateCurrentLocation('false');
                })
        }

        const communityId = localStorage.getItem('communityId');

        if (communityId && communityId.length > 0 && this.state.communitySelected === undefined) {
            const objCommunity = this.GetCommunityObjectForSupuerUserCombo(communityId);
            if (objCommunity) {

                setTimeout(() => {

                    this.setState({ selectedCommunityImage: objCommunity.communityLogoUrl, communitySelected: objCommunity },
                        this.SetHeaderButtons(
                            {
                                openResident: this.state.openResident,
                                openCommunity: this.state.openCommunity,
                                openDevice: this.state.openDevice,
                                openCommunitySettings: this.state.oppenCommunitySettings,
                                isUpdateDevice: this.state.isUpdateDevice,
                                isUpdResident: this.state.isUpdResident,
                                selectedDevices: this.state.selectedDevices,
                                communityExists: this.state.communityExists,
                                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                communitySelected: objCommunity,
                                community: objCommunity,
                            }
                        )

                    );
                }, 100);

            }
        }

        if (this.props.tableData && this.props.communityAdded && this.state.isAddCommunity) {
            const indexOfCommunityAdded = this.props.tableData.map((item) => item.communityName).indexOf(this.props.communityAdded.communityName)

            if (indexOfCommunityAdded > -1) {

                this.setState({ currentPage: Number(Math.ceil((indexOfCommunityAdded + 1) / itemPerPage)), isAddCommunity: false })

            }


        }





        return (
            <React.Fragment>
                {localStorage.getItem('superAdmin') === "true" || (this.state.openResident || this.state.openCommunity || this.state.openDevice || this.state.openCommunitySettings) ?
                    <this.AppBarContainer />
                    :
                    undefined
                }
                <main className={this.state.openLocation === true || this.state.openNewLocation === true ? 'content-engage-community-v3' : this.state.openCommunity === true || this.state.openResident === true ? "content-engage-community-v2" : "content-engage-community"} style={{ padding: (this.state.openCommunity) ? '0px' : '15px' }}>
                    <div className="activityTitle-engage">
                        {this.state.openCommunity ?
                            <AddEditCommunity closeDialog={this.handleClose}
                                data={this.state.community}
                                handleIsUpdResident={(state = true) => {
                                    this.setState({ isUpdResident: state },

                                        this.SetHeaderButtons(
                                            {
                                                openResident: this.state.openResident,
                                                openCommunity: this.state.openCommunity,
                                                openDevice: this.state.openDevice,
                                                openCommunitySettings: this.state.oppenCommunitySettings,
                                                isUpdateDevice: this.state.isUpdateDevice,
                                                selectedDevices: this.state.selectedDevices,
                                                isUpdResident: state,
                                                communityExists: this.state.communityExist,
                                                onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                            }
                                        )
                                    );
                                }}
                                handleCommunityExist={this.handleCommunityExist.bind(this)}
                                communityExists={this.state.communityExists}
                                handleTabSelectedChange={(tab = 0) => { this.setState({ tabSelected: tab }); }}
                                tabSelected={this.state.tabSelected}
                                enableButton={this.enableSyncButton}
                                disableButton={this.disableSyncButton}
                            />
                            : this.state.openResident ?
                                <AddEditResdient closeDialog={this.handleClose}
                                    data={this.state.community}
                                    openFilters={this.state.residentFiltersOpen}
                                    filtersAnchorElId={this.state.residentsFiltersAnchorElId}
                                    closeFilters={this.handleFilterClick}
                                    handleIsUpdResident={(state = false) => {
                                        this.setState({ isUpdResident: state },

                                            this.SetHeaderButtons(
                                                {
                                                    openResident: this.state.openResident,
                                                    openCommunity: this.state.openCommunity,
                                                    openDevice: this.state.openDevice,
                                                    openCommunitySettings: this.state.oppenCommunitySettings,
                                                    isUpdateDevice: this.state.isUpdateDevice,
                                                    selectedDevices: this.state.selectedDevices,
                                                    isUpdResident: state,
                                                    communityExists: this.state.communityExist,
                                                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                }
                                            )
                                        );
                                    }}
                                    handleCommunityExist={this.handleCommunityExist.bind(this)}
                                    communityExists={this.state.communityExists}
                                    handleTabSelectedChange={(tab = 0) => { this.setState({ tabSelected: tab }); }}
                                    handlerOnErrorFirstName={(isDisabled) => {
                                        this.setState({ onErrorSelectedResidentFirstName: isDisabled },

                                            this.SetHeaderButtons(
                                                {
                                                    openResident: this.state.openResident,
                                                    openCommunity: this.state.openCommunity,
                                                    openDevice: this.state.openDevice,
                                                    openCommunitySettings: this.state.oppenCommunitySettings,
                                                    isUpdateDevice: this.state.isUpdateDevice,
                                                    selectedDevices: this.state.selectedDevices,
                                                    isUpdResident: this.state.isUpdResident,
                                                    communityExists: this.state.communityExist,
                                                    onErrorSelectedResidentFirstName: isDisabled,
                                                    onErrorSelectedResidentLastName: this.state.onErrorSelectedResidentLastName,
                                                }
                                            )
                                        );
                                    }}
                                    handlerOnErrorLastName={(isDisabled) => {
                                        this.setState({ onErrorSelectedResidentLastName: isDisabled },
                                            this.SetHeaderButtons(
                                                {
                                                    openResident: this.state.openResident,
                                                    openCommunity: this.state.openCommunity,
                                                    openDevice: this.state.openDevice,
                                                    openCommunitySettings: this.state.oppenCommunitySettings,
                                                    isUpdateDevice: this.state.isUpdateDevice,
                                                    selectedDevices: this.state.selectedDevices,
                                                    isUpdResident: this.state.isUpdResident,
                                                    communityExists: this.state.communityExist,
                                                    onErrorSelectedResidentFirstName: this.state.onErrorSelectedResidentFirstName,
                                                    onErrorSelectedResidentLastName: isDisabled,
                                                }
                                            )
                                        );
                                    }}
                                />
                                : this.state.openDevice ?
                                    <AddEditDeviceV2 closeDialog={this.handleClose}
                                        data={this.state.communitySelected}
                                        handleCommunityExist={this.handleCommunityExist.bind(this)}
                                        isUpdateDevice={(isUpdateDevice, deviceSelected) => this.handleIsUpdateDevice(isUpdateDevice, deviceSelected)}
                                        isSelectedDevices={(selectedDevices) => this.handleIsSelectedDevices(selectedDevices)}
                                        communityExists={this.state.communityExists}
                                        openFilters={this.state.deviceFiltersOpen}
                                        filtersAnchorElId={this.state.deviceFiltersAnchorElId}
                                        closeFilters={this.handleDeviceFiltersClick}
                                        umbralInMinutes={(this.state && this.state.umbralInMinutes) ? this.state.umbralInMinutes : 5}
                                    />
                                    :
                                    this.state.openLocation ?

                                        <Locations
                                            communitySelected={this.state?.communitySelected}
                                            onClose={this.handlerOnLocationsClose}
                                            handlerOpenElementDetails={this.handlerOpenElementDetails}
                                            handlerCloseElementDetails={this.handlerCloseElementDetails}


                                        />
                                        :
                                        this.state.openApps ?
                                            <AppsView
                                                communitySelected={this.state.communitySelected}
                                                handleClose={this.handleCommunitySettingsClose}
                                                rootFontSize={this.state.rootFontSize}
                                            />
                                            // : this.state.openNewLocation ?
                                            // <LocationsV2
                                            //     communitySelected={this.state?.communitySelected}
                                            //     onClose={this.handlerOnLocationsClose}
                                            //     handlerOpenElementDetails={this.handlerOpenElementDetails}
                                            //     handlerCloseElementDetails={this.handlerCloseElementDetails}
                                            // />
                                            :
                                            this.state.openCommunitySettings && this.state.communitySelected ?
                                                <CommunitySettings
                                                    communitySelected={this.state.communitySelected}
                                                    handleClose={this.handleCommunitySettingsClose}
                                                    rootFontSize={this.state.rootFontSize}
                                                />
                                                :
                                                <Grid item container xs={12} sm={12} md={12} lg={12}>
                                                    <Grid container item xs={12} style={{ margin: '10px' }} >
                                                        <Grid xs={12} item container>
                                                            <Grid xs={12} sm={12} md={12} lg={6} item container justifyContent='center' alignItems='center'>
                                                                <Grid item container xs={12} justifyContent='center' alignItems='center'>


                                                                    <Grid item style={{ position: 'relative', }}>
                                                                        {
                                                                            this.state.communitySelected === undefined ?
                                                                                <Grid item style={{ position: 'absolute', top: 0, left: 0, borderRadius: '50%', width: '23rem', height: '23rem', zIndex: '16' }} onClick={() => sweetAlert('error', 'You must select a community ')} />
                                                                                :
                                                                                undefined
                                                                        }

                                                                        <RenderImageLoaderCommunity
                                                                            id='community_communityLogo'
                                                                            styleCardContentStyles={{ width: '22rem', height: '22rem' }}
                                                                            styleInputFileStyles={{ border: '1px solid yellow' }}
                                                                            imageStyles={{ backgroundColor: '#000' }}
                                                                            divTextStyles={{ bottom: '0px', }}
                                                                            text='Edit'
                                                                            imageUrl={this.state.selectedCommunityImage}
                                                                            disabled={this.state.communitySelected === undefined}
                                                                            imageName='Details Image'
                                                                            onChange={(e) => this.readImage(e, 'communityImage')}
                                                                        />
                                                                        <Grid container style={{ marginTop: '30px' }}>
                                                                            <Grid item xs={12} style={this.titleEngage} >
                                                                                Community Logo
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <this.CommunityComponent />

                                                        </Grid>
                                                    </Grid>
                                                    <br /><br />
                                                    <Grid container item xs={12} style={{ margin: '40px 10px' }}>
                                                        <Grid item container xs={12} >
                                                            <this.ActionsComponent />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                        }
                    </div>

                    <Modal
                        open={this.state.showModalSyncCL}
                        onClose={() => this.setState({ showModalSyncCL: false })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ borderRadius: '16px' }}
                    >
                        <ModalExternalIdBind
                            OnCancelHandler={this.OnCancelHandler}
                            SyncCLCommunity={this.OnSyncCLCommunity}
                        />
                    </Modal>

                </main>
            </React.Fragment>
        );
    }
};


function mapStateToProps(state) {

    let communityData = (state.communityReducer && state.communityReducer.communityData) ? state.communityReducer.communityData : undefined;
    let returnToHome = (state && state.currentUrlReducer && state.currentUrlReducer.returnToHome) ? state.currentUrlReducer.returnToHome : 'false'

    if (communityData) {
        communityData =
            communityData.map((item, index) => {
                item.indexForCombo = index;
                return item;
            })
    }

    return {
        tableData: communityData,
        communityAdded: state.communityReducer && state.communityReducer.communityAdded,
        returnToHome: returnToHome
    };
};

// Community = reduxForm({
//     form: 'CommunityForm',
//     validate,
//     enableReinitialize: true,
// })(Community);

export default connect(mapStateToProps, { getAllCommunities, getCommunityById, delCommunity, getCommunityByIdAsync, UpdateCommuntyImage, GetAllDevices, SetHeaderButtons, ClearVersions, ClearDevices, UpdateCurrentLocation })(Community)